import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Typography } from '@mui/material';
import queryString from 'query-string';
import { unsubscribe } from 'actions/SubmissionActions';

export class UnsubscribePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      success: false
    }
  }

  componentDidMount() {
    const { promotion, location } = this.props;

    const params = queryString.parse(location.search);
    this.props.unsubscribe(promotion.id, params.token, () => { this.setState({success: true})});
  }

  render() {
    return (
      <center>
        {this.state.success &&
          <Typography>You have been successfully unsubscribed</Typography>
        }
      </center>
    )
  }
}

const mapDispatchToProps = {
  unsubscribe: (promotionId, token, successCallback) => unsubscribe(promotionId, token, successCallback)
};

export default withRouter(connect(null, mapDispatchToProps)(UnsubscribePage));
